import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { BlurView } from '@sbaiahmed1/react-native-blur';
import React from 'react';
import { Dimensions, Image, Modal, Platform, StyleSheet } from 'react-native';
import styled from 'styled-components/native';
import { SccButton } from '@/components/atoms';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
const TITLE_IMAGE_BY_VARIANT = {
    mission: require('@/assets/img/tutorial/mission_complete_title.png'),
    'outing-items': require('@/assets/img/tutorial/outing_items_collected_title.png'),
};
// Figma popup img frame: 390x200 (frame 폭 기준). 화면 폭에 맞춰 비례 적용.
const SCREEN_WIDTH = Dimensions.get('window').width;
const POPUP_IMG_DESIGN_RATIO = 200 / 390;
const POPUP_IMG_WIDTH = SCREEN_WIDTH;
const POPUP_IMG_HEIGHT = POPUP_IMG_WIDTH * POPUP_IMG_DESIGN_RATIO;
export default function MissionCompletedOverlay({ isVisible, itemImage, description, confirmElementName, confirmLogParams, variant = 'mission', onClose, }) {
    return (_jsxs(Modal, { visible: isVisible, transparent: true, animationType: "fade", statusBarTranslucent: true, onRequestClose: onClose, children: [_jsx(BlurView, { style: StyleSheet.absoluteFill, blurType: Platform.OS === 'ios' ? 'dark' : 'extraDark', blurAmount: Platform.OS === 'ios' ? 35 : 6, overlayColor: "rgba(0,0,0,0.8)" }), _jsx(DimContent, { children: _jsxs(Contents, { children: [_jsx(TitleImage, { source: TITLE_IMAGE_BY_VARIANT[variant], resizeMode: "contain" }), _jsx(Image, { source: itemImage, style: { width: POPUP_IMG_WIDTH, height: POPUP_IMG_HEIGHT }, resizeMode: "contain" }), _jsx(FormattedDescription, { description: description }), _jsx(SccButton, { text: "\uD655\uC778", elementName: confirmElementName, logParams: confirmLogParams, onPress: onClose, buttonColor: "brand40", textColor: "white", fontFamily: font.pretendardSemibold, fontSize: 18, width: 140, height: 56, style: { borderRadius: 8 } })] }) })] }));
}
const DimContent = styled.View `
  flex: 1;
  align-items: center;
  justify-content: center;
`;
const Contents = styled.View `
  align-items: center;
  gap: 20px;
`;
const TitleImage = styled.Image `
  width: 322px;
  height: 56px;
`;
/**
 * Figma 1648:39361 기준: 첫 줄(획득 문구)은 Bold, 그 다음 줄들은 Medium.
 * 한 `<Text>` 안에 nested Text로 두 weight를 섞어 동일 lineHeight/letterSpacing 유지.
 */
function FormattedDescription({ description }) {
    const newlineIdx = description.indexOf('\n');
    const titleLine = newlineIdx === -1 ? description : description.slice(0, newlineIdx);
    const bodyLine = newlineIdx === -1 ? '' : description.slice(newlineIdx);
    return (_jsxs(Description, { children: [_jsx(DescriptionTitle, { children: titleLine }), bodyLine] }));
}
// Figma 1648:39361 기준, 박원 디자이너 수정안 (2026-05-27): fontSize 20→18pt.
// Medium 18/26, 폭 311, white, text-shadow 0 0 4 rgba(0,0,0,0.25).
const Description = styled.Text.attrs({
    style: {
        textShadowColor: 'rgba(0, 0, 0, 0.25)',
        textShadowOffset: { width: 0, height: 0 },
        textShadowRadius: 4,
    },
}) `
  max-width: 90%;
  font-family: ${font.pretendardMedium};
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.4px;
  text-align: center;
  color: ${color.white};
`;
// 첫 줄(획득 메시지)만 Bold weight로 강조.
const DescriptionTitle = styled.Text `
  font-family: ${font.pretendardBold};
  color: ${color.white};
`;
